import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../services/analytics.service';
import { Subscription } from 'rxjs';
import { JsonDataService } from '../../services/json-data.service';
@Component({
  selector: 'app-help-support',
  standalone: true,
  imports: [CommonModule, RouterModule,],
  templateUrl: './help-support.component.html',
  styleUrl: './help-support.component.scss'
})
export class HelpSupportComponent {

  environment: any = environment;
  sub: Subscription = new Subscription();
  customerCareInfo: any;
  isContactPage = false;
  contactData: any = {};
  constructor(public utils: UtilsService, public router: Router, public analyticsService: AnalyticsService, private jsonDataService: JsonDataService) {
    this.sub.add(this.jsonDataService.getHelpSupportJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        this.contactData = res;
      },
      error: (err: any) => {
        this.utils.hideLoading();
        console.error('Error fetching meta data', err);
      }
    }));
  }

  ngOnInit() {
    this.isContactPage = this.router.url === '/contact-us';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }
}
